import { render, staticRenderFns } from "./soms.vue?vue&type=template&id=189b4dec&scoped=true"
import script from "./soms.vue?vue&type=script&lang=js"
export * from "./soms.vue?vue&type=script&lang=js"
import style0 from "./soms.vue?vue&type=style&index=0&id=189b4dec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b4dec",
  null
  
)

export default component.exports